export const BULK_ACTIONS_TYPES = {
  DELETE: "delete",
  DUPLICATE: "duplicate"
};

export const BULK_ACTIONS_DIALOG_DATA = {
  DELETE: {
    title: (rowsCount, pluralSuffix) => `Confirm ${rowsCount} row${pluralSuffix} deletion`,
    content: (rowsCount, pluralSuffix) => `You're about to delete ${rowsCount} row${pluralSuffix}. Are you sure you want to proceed?`,
    submitButtonText: "Delete",
    confirmColor: "error"
  },
  DUPLICATE: {
    title: (rowsCount, pluralSuffix) => `Confirm ${rowsCount} row${pluralSuffix} duplication`,
    content: (rowsCount, pluralSuffix) => `You're about to duplicate ${rowsCount} row${pluralSuffix}. Are you sure you want to proceed?`,
    submitButtonText: "Yes",
    confirmColor: "primary"
  }
};

export const BULK_EDIT_MODES = {
  REPLACE: "replace",
  PREFIX: "prefix",
  SUFFIX: "suffix"
};

export const BULK_EDIT_MODE_OPTIONS = [
  {
    key: BULK_EDIT_MODES.REPLACE,
    display_key: "Replace entire value"
  },
  {
    key: BULK_EDIT_MODES.PREFIX,
    display_key: "Add prefix"
  },
  {
    key: BULK_EDIT_MODES.SUFFIX,
    display_key: "Add suffix"
  }
];

export const BULK_EDIT_MODE_PLACEHOLDERS = {
  [BULK_EDIT_MODES.REPLACE]: "Enter new value",
  [BULK_EDIT_MODES.PREFIX]: "Add at start",
  [BULK_EDIT_MODES.SUFFIX]: "Add at end"
};

export const BULK_MULTI_LANG_PLACEHOLDER = "Keep current";

export const BULK_FIELD_HEIGHT = "38px";
export const BULK_FIELD_BORDER_RADIUS = "8px";
export const BULK_FIELD_FONT_SIZE = 14;
export const BULK_FIELD_ERROR_POPPER_WIDTH = "300px";
